
export const CREATE = 'create'
export const EDIT = 'edit'
export const VIEW = 'view'
